import postWithToken from "./base/post-with-token";

const downloadBlobAzure = (data) =>
  postWithToken(`/devices/download-blob`, { responseType: "blob" })(data);

export default downloadBlobAzure;
